export enum TypeProprieteEnum {
  Maison = 'MAISON',
  Condo = 'CONDO',
  Autre = 'AUTRE'
}
